import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Cookies } from 'react-cookie';
import {
  COOKIE_OPTIONS,
  SUPPORTED_LNGS,
  SUPPORTED_LNGS_ALIAS,
} from '../constants';

import en from './en/translation.json';

const defaultLng = 'en';
const ck = new Cookies();
const langCookieName = 'lang';

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources: {
    en,
  },
  fallbackLng: defaultLng,
  supportedLngs: SUPPORTED_LNGS,
  debug: false,
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['cookie', 'navigator'],
    lookupCookie: '',
    caches: ['cookie'],
    cookieOptions: COOKIE_OPTIONS,
  },
});

for (let lng of i18n.services.languageDetector.detect()) {
  console.log('browser has:', lng);
}

const convertToSupportedLangIfIntersect = (navLang) => {
  for (const iterLang of SUPPORTED_LNGS) {
    for (const iterLangAlias of SUPPORTED_LNGS_ALIAS[iterLang]) {
      if (navLang.toLowerCase().indexOf(iterLangAlias) !== -1){
          return iterLang;
      }
    }      
  }
  return ''; /* meaning user's lang preference doesn't intersect with what we support*/
};

const navLang = convertToSupportedLangIfIntersect(window.navigator.language);

let chooseLang;
if (!ck.get(langCookieName)) {
  if (navLang !== '') {
    ck.set(langCookieName, navLang, COOKIE_OPTIONS);
    chooseLang = navLang;
  } else {
    ck.set(langCookieName, defaultLng, COOKIE_OPTIONS);
    chooseLang = defaultLng;
  }
} else {
  chooseLang = ck.get(langCookieName);
  console.log('language decided:', chooseLang);
}
console.log('ha chooseLang', chooseLang);
i18n.changeLanguage(chooseLang);
export default i18n;